import { render, staticRenderFns } from "./report-list.vue?vue&type=template&id=0f279ec8&"
import script from "./report-list.vue?vue&type=script&lang=ts&"
export * from "./report-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports